import { render, staticRenderFns } from "./WHGender.vue?vue&type=template&id=940574ec&"
import script from "./WHGender.vue?vue&type=script&lang=js&"
export * from "./WHGender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports